export const PcStackSourceEnum = Object.freeze({
  WINDBG: 'WINDBG',
  LINUX_BREAKPAD: 'LINUX_BREAKPAD',
  WINDOWS_BREAKPAD: 'WINDOWS_BREAKPAD',
});
